import { faPencil } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import Modal from './Modal'

// Componente che mostra un box per avvertire l'utente che l'operazione di richiesta di un preventivo è
// assai veloce, quando tenta di abbandonare la pagina
const AbandonAlert: React.FC = () => {
  const [show, setShow] = useState(false)
  const shown = useRef<boolean>(false)

  useEffect(() => {
    const handler = () => {
      if (shown.current) return
      else {
        setShow(true)
        shown.current = true
      }
    }
    document.body.addEventListener('mouseleave', handler)
    return () => document.body.removeEventListener('mouseleave', handler)
  }, [])

  if (!show) return null

  return (
    <Modal title="ASPETTA!" onClose={() => setShow(false)}>
      Basta solo 1 minuto per terminare la tua richiesta online
      <ContinueButton type="button" onClick={() => setShow(false)}>
        <FontAwesomeIcon icon={faPencil} aria-hidden="true" />
        <span>CONTINUA E CHIEDI IL PREVENTIVO</span>
      </ContinueButton>
    </Modal>
  )
}

export default AbandonAlert

//region Style

// Era uno <a> senza href: non focusabile e inerte da tastiera (WCAG 2.1.1).
// Non naviga, chiude il dialog: quindi e' un <button>.
const ContinueButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.8rem;
  width: 100%;
  max-width: 33rem;
  min-height: 45px;
  margin: 2.5rem auto 0;
  padding: 0.8rem 1.5rem;
  border: 0;
  border-radius: 20px;
  background-color: #ffffff;
  /* #1f1f1f su #ffffff = 15.9:1 */
  color: #1f1f1f;
  font-family: inherit;
  font-size: 15px;
  font-weight: 700;
  text-align: center;
  cursor: pointer;

  &:focus {
    outline: none;
  }
  &:focus-visible {
    outline: 3px solid #005fcc;
    outline-offset: 2px;
  }
`
//endregion
